import { render, staticRenderFns } from "./segmentReportList.vue?vue&type=template&id=1ae08a20"
import script from "./segmentReportList.vue?vue&type=script&lang=js"
export * from "./segmentReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports